// extracted by mini-css-extract-plugin
module.exports = {"test":"src-main__test--1Si6g"};